export const SITE_CARE_MODES = {
  DOCTOR_ONLY: 'DOCTOR_ONLY',
  DOCTOR_NURSE_NO_PHARMACY: 'DOCTOR_NURSE_NO_PHARMACY',
  NURSE_ONLY_NO_PHARMACY: 'NURSE_ONLY_NO_PHARMACY',
  WITH_PHARMACY: 'WITH_PHARMACY'
};

export const STOCK_LOCATIONS = {
  MAIN: 'MAIN',
  DUTY: 'DUTY'
};

export function siteHasDutyCabinet(site) {
  if (!site) return false;
  return Number(site.is_central_pharmacy) === 1 && Number(site.has_duty_cabinet) === 1;
}

export function canNurseAccessLocalPharmacy(site) {
  if (!site) return false;
  if (siteHasDutyCabinet(site)) return true;
  return [
    SITE_CARE_MODES.NURSE_ONLY_NO_PHARMACY,
    SITE_CARE_MODES.DOCTOR_NURSE_NO_PHARMACY
  ].includes(site.site_care_mode);
}

export function canDoctorAccessLocalPharmacy(site) {
  if (!site) return false;
  return [SITE_CARE_MODES.DOCTOR_ONLY].includes(site.site_care_mode);
}

export function canPharmacistAccessLocalPharmacy(site) {
  if (!site) return false;
  return Number(site.has_local_pharmacy) === 1 || site.site_care_mode === SITE_CARE_MODES.WITH_PHARMACY;
}

export function canRoleAccessLocalPharmacy(role, site) {
  if (!site || !role) return false;
  const normalized = String(role || '').toLowerCase();
  if (normalized === 'pharmacist' || normalized === 'admin pharmacist') {
    return canPharmacistAccessLocalPharmacy(site);
  }
  if (normalized === 'nurse' || normalized === 'major') return canNurseAccessLocalPharmacy(site);
  if (normalized === 'doctor' || normalized === 'dentist') return canDoctorAccessLocalPharmacy(site);
  return false;
}

/** Lieu de stock pour nurse/major : DUTY sur centrale+armoire, sinon MAIN. */
export function resolveLocalPharmacyStockLocation(role, site) {
  const normalized = String(role || '').toLowerCase();
  if ((normalized === 'nurse' || normalized === 'major') && siteHasDutyCabinet(site)) {
    return STOCK_LOCATIONS.DUTY;
  }
  return STOCK_LOCATIONS.MAIN;
}

export function isLocalPharmacyDutyCabinet(role, site) {
  return resolveLocalPharmacyStockLocation(role, site) === STOCK_LOCATIONS.DUTY;
}
